import { readBarcodes, type ReaderOptions } from "zxing-wasm/reader";

export type DecodeResult = { text: string } | null;

const READER_OPTIONS: ReaderOptions = {
  formats: ["DataMatrix"],
  tryHarder: true,
  tryInvert: true,
  tryRotate: true,
  tryDownscale: true,
  maxNumberOfSymbols: 1,
};

export async function decodeFrame(imageData: ImageData): Promise<DecodeResult> {
  const results = await readBarcodes(imageData, READER_OPTIONS);
  const first = results[0];
  if (!first) {
    return null;
  }
  return { text: first.text };
}
